/**
 * Friendly empty states — no data vs no results from filters.
 */
import React from 'react';

export default function EmptyState({ variant = 'no-data', onClearFilters }) {
  if (variant === 'no-results') {
    return (
      <div className="py-16 text-center">
        <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-4">
          <svg className="w-8 h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z" />
          </svg>
        </div>
        <p className="text-slate-600 font-medium">No items match your filters</p>
        <p className="text-slate-500 text-sm mt-1 max-w-sm mx-auto">
          Try adjusting your filters or clear them to see all items.
        </p>
        {onClearFilters && (
          <button
            type="button"
            onClick={onClearFilters}
            className="mt-4 px-4 py-2 rounded-lg bg-slate-100 hover:bg-slate-200 text-slate-700 font-medium text-sm"
          >
            Clear filters
          </button>
        )}
      </div>
    );
  }

  return (
    <div className="py-16 text-center">
      <div className="w-16 h-16 rounded-2xl bg-slate-100 flex items-center justify-center mx-auto mb-4">
        <svg className="w-8 h-8 text-slate-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
        </svg>
      </div>
      <p className="text-slate-600 font-medium">No obligations yet</p>
      <p className="text-slate-500 text-sm mt-1 max-w-sm mx-auto">
        Ingest the CMS calendar or upload a state Medicaid contract to get started.
      </p>
    </div>
  );
}
